import { Fragment } from "react";
import { BiCopy } from "react-icons/bi";
import { FaRegUser } from "react-icons/fa";
import { Link } from "react-router-dom";

const ProfileCard = ({ data, loading = false }) => {
  const id = data.uuid;
  // Use env base URL if provided (avoid hardcoded localhost).
  // Fallback to current origin for local/dev.
  const baseUrl = process.env.REACT_APP_FRONTEND_URL || window.location.origin;
  const jobApplicationUrl = `${baseUrl}/job-application/${id}`;
  return (
    <div className="flex flex-col gap-2 pb-4 p-4 bg-white rounded-md">
      <div className="flex flex-col flex-1 leading-none gap-1">
        {loading ? (
          <Fragment>
            <span
              className={`animate-pulse h-3 rounded-sm w-full bg-bghoverlight`}
            ></span>
            <span
              className={`animate-pulse h-3 rounded-sm w-full bg-bghoverlight`}
            ></span>
          </Fragment>
        ) : (
          <Fragment>
            <span className="text-2xl font-bold text-theme truncate">
              {data?.title}
            </span>
            <span className="truncate leading-4 text-theme">
              Department- {data?.department?.name}
            </span>
          </Fragment>
        )}
      </div>
      <div className="flex flex-row gap-2">
        <h2 className="text-theme text-sm"> Public Form - </h2>
        <span className="text-theme text-sm flex items-center gap-1">
          <BiCopy />
          <Link
            to={jobApplicationUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-40 truncate"
          >
            {jobApplicationUrl}
          </Link>
        </span>
      </div>
    </div>
  );
};

export default ProfileCard;
